import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal, Divider, Row, Col } from '_zari/core'

import * as CuentaContableCrud from 'services/cuentaContable.service'

import * as FormGroups from './formGroups'

import { DownloadAxiosFile } from 'utils'


const ImportarModal = ({ handleClose, show, reloadTree }) => {
  const __zariContext = React.useContext(ZariContext)
  const formInitialValues = React.useMemo(
    () => ({
      file: ''
    }),
    []
  )

  const submitHandler = data => {
    const submitData = new FormData()
    submitData.append('file', data.file)

    CuentaContableCrud.importarCuentasContables(submitData)
      .then(() => {
        __zariContext.snack('success', 'Se han actualizados las cuentas contables.')
        reloadTree()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  const clickDescargarPlantilla = React.useCallback(() => {
    CuentaContableCrud.descargarPlantillaImportarCuentas().then(({ data, headers }) => {
      DownloadAxiosFile.downloadAsBlob(data, headers, 'Importar cuentas.xlsx')
    })
  }, [])

  const clickReporteErrores = React.useCallback(file => {
    const submitData = new FormData()
    submitData.append('file', file)

    CuentaContableCrud.reporteErroresImportacionCuentas(submitData)
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers, 'Reporte errores cuentas contables.xlsx')
        __zariContext.snack('success', 'Reporte de errores generado.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])


  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>IMPORTAR CUENTAS CONTABLES</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue, values }) => ( // MOD: +values
          <Form>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <Button outline block onClick={clickDescargarPlantilla}>
                    Descargar plantilla
                  </Button>
                </Col>
              </Row>
              <Divider />
              <FormGroups.FileFormGroup
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                iError={errors.file}
                iTouched={touched.file}
              />
            </Modal.Body>

            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>

              {values.file ? (
                <Button color='warning' onClick={() => clickReporteErrores(values.file)}>
                  Reporte Errores
                </Button>
              ) : null}

              <Button onClick={handleSubmit}>Importar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default ImportarModal
